import moment from 'moment/moment';

import { CompanyMessage } from '~/data/company';
import { UseDialogStateOutput, useDialogState } from '~/hooks/useDialogState';
import { useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const getCompanyMessage = (): Promise<CompanyMessage> =>
  fetchFromOldApi('/json/company/message').then((r) => r.json());

type UseGetCompanyMessage = {
  isLoading: boolean;
  failedToLoad: boolean;
  message?: string;
  messageDate?: string;
};

export const useGetCompanyMessage = (): UseGetCompanyMessage => {
  const {
    data: companyMessage,
    isLoading,
    failedToLoad,
  } = useSWR('getCompanyMessage', getCompanyMessage);
  const messageDate = companyMessage
    ? moment(companyMessage.fCompanyMessageUpdatedTime).toISOString()
    : undefined;
  const message = companyMessage?.fCompanyMessage;

  return {
    isLoading,
    failedToLoad,
    message,
    messageDate,
  };
};

type UseCompanyInformationDialog = UseGetCompanyMessage & {
  isAvailable: boolean;
  isDisabled: boolean;
  onOpen: UseDialogStateOutput['open'];
  dialogProps: {
    open: UseDialogStateOutput['isOpen'];
    onClose: UseDialogStateOutput['close'];
  };
};

export const useCompanyInformationDialog = (): UseCompanyInformationDialog => {
  const { isOpen, open, close } = useDialogState();
  const companyMessage = useGetCompanyMessage();

  return {
    ...companyMessage,
    isAvailable: !!companyMessage.message,
    isDisabled: companyMessage.isLoading || companyMessage.failedToLoad,
    onOpen: open,
    dialogProps: {
      open: isOpen,
      onClose: close,
    },
  };
};
